import { useExperiment } from '@coursera-web/statsig';

import useIsConsumerSerp from 'bundles/search-common/utils/useIsConsumerSerp';

const EXPERIMENT_NAME = 'two_panel_search';
const PARAM_NAME = 'enable_search_ai';

/**
 * Two-panel SERP assignment with exposure logging. Exposure fires only on
 * the consumer SERP.
 */
export const useTwoPanelSearchExperiment = (): boolean => {
  const isConsumerSerp = useIsConsumerSerp();
  const experiment = useExperiment(EXPERIMENT_NAME, { disableExposureLog: !isConsumerSerp });
  if (!isConsumerSerp) {
    return false;
  }
  return experiment.get(PARAM_NAME, false);
};
